const APIPaths = require('./src/APIPaths.js');
const { formatExpressToApiGWPath } = require('./src/APIPathUtils.js');

exports.APIPaths = APIPaths;
exports.formatExpressToApiGWPath = formatExpressToApiGWPath;